<template>
    <footer class="bg-white py-12 lg:py-10" style="box-shadow: 0 -4px 6px -2px rgba(0, 0, 0, 0.1)">
        <div class="container">
            <div class="flex flex-col lg:flex-row lg:justify-between mb-10">
                <div class="lg:w-2/12 mb-9 lg:mb-0 max-w-[11.125rem]">
                    <Logo />

                    <div class="flex gap-2 mt-2">
                        <a href="https://www.facebook.com/sulibox/" target="_blank" class="w-8 h-8">
                            <FacebookLogo />
                        </a>

                        <a href="https://www.instagram.com/sulibox/" target="_blank" class="w-8 h-8">
                            <InstagramLogo />
                        </a>
                    </div>
                </div>
                <div class="lg:w-4/12 lg:text-right flex flex-col gap-y-3">
                    <span class="font-Open-Sans-Regular"><T t="generic.company-name" /></span>
                    <a
                        :href="$i18n.locales.find((x) => x.code === $i18n.locale).google_maps_url"
                        class="font-Open-Sans-Regular"
                        target="_blank"
                    >
                        <span> <T t="generic.address-title" /></span>:&nbsp;<span class="underline">
                            <T t="generic.address" />
                        </span>
                    </a>
                    <a :href="`tel:${$t('generic.tel-number')}`" class="font-Open-Sans-Regular">
                        <span><T t="generic.tel" /></span>:&nbsp;
                        <span class="underline"><T t="generic.tel-number" /> </span>
                    </a>
                    <a :href="`mailto:${$t('generic.email-address')}`" class="font-Open-Sans-Regular">
                        <span><T t="generic.email" /></span>:&nbsp;
                        <span class="underline"><T t="generic.email-address" /></span>
                    </a>
                </div>
            </div>
            <div
                class="flex flex-col lg:flex-row lg:items-center text-grey-800 gap-x-14 pt-9 lg:pt-10 border-t border-white border-opacity-15 gap-y-2 lg:gap-y-0"
            >
                <a download class="hover:underline" :href="`/pdf/${$i18n.locale}/privacy-policy.pdf`">
                    <T t="generic.privacy-policy" />
                </a>

                <a
                    v-if="$i18n.locale === 'hu'"
                    download
                    class="hover:underline"
                    :href="`/pdf/${$i18n.locale}/sulibox_felhasznalasi_feltetelek.pdf`"
                >
                    Felhasználási feltételek
                </a>

                <span>
                    <span> <T t="footer.more-information" /> </span>&nbsp;
                    <a :href="`tel:${$t('generic.tel-number')}`" class="underline hover:underline">
                        <T t="generic.tel-number" />
                    </a>
                </span>
            </div>
        </div>
    </footer>
</template>

<script>
import Logo from '../UI/Logo';
import InstagramLogo from '../Logos/InstagramLogo';
import FacebookLogo from '../Logos/FacebookLogo';

export default {
    name: 'Footer',
    components: {
        Logo,
        InstagramLogo,
        FacebookLogo,
    },
};
</script>

<style scoped></style>
